<template>
    <div>
        <div
            class="mt-input mt-input--growable"
            :class="{ disabled, active, filled, 'invalid': errorMessage }"
            @click="active = true; $emit('click', $event)"
        >
            <div
                v-if="coins"
                class="coins"
            >{{ coins }}</div>
            <div
                v-if="label"
                class="label"
                :class="{ 'hold-place': !filled }"
            >{{ label }}</div>
            <textarea
                ref="area"
                class="multiple-area"
                v-if="!chip && isMultipleLines"
                @select="clearTextSelection"
                @selectionstart="() => false"
                :value="currentValue"
                autocomplete="off"
                @focus="active = true"
                readonly
            >
            </textarea>
            <input
                v-else-if="!chip"
                ref="input"
                class="mt-input__value"
                type="text"
                @select="clearTextSelection"
                @selectionstart="() => false"
                :value="currentValue"
                autocomplete="off"
                @focus="active = true"
                readonly
            >
            <div
                v-if="chip"
                class="mt-input__value"
            >
                <div
                    class="chip"
                    v-if="currentValue !== ''"
                >
                    <span class="text">{{ currentValue }}</span>
                    <span class="close" @click.stop="removeItem"></span>
                </div>
            </div>
            <CloseIcon v-else-if="withClear && currentValue" class="clear-icon" @click.stop="removeItem" />

            <div class="mt-input__value__arrow"></div>

            <div class="mt-input__select mt-input__select--searchable" v-if="active">

                <div
                    class="head"
                >
                    <div class="search">
                        <font-awesome-icon class="icon" icon="search"/>
                        <input
                            class="mt-input__value"
                            type="text"
                            ref="vinput"
                            @input="inputf"
                            @blur="blurClose"
                            autocomplete="off"
                        >
                    </div>
                </div>

                <div class="body">
                    <div class="mt-input__select__item mt-input__value"
                        v-for="(item, index) in items"
                        :key='index'
                        @mousedown="emitValue($event, item)"
                        :class="{ selected: getValue(item) === value}"
                    >{{getText(item)}}</div>
                </div>
            </div>
        </div>
        <div v-if="errorMessage" class="mt-invalid">
            <div class="mt-invalid-text">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
import debounce from '@/tools/debounce';
import CloseIcon from '@/assets/images/close-circle-black.svg?inline';


export default {
    name: 'ModelAutoComplete',

    components: {
        CloseIcon,
    },

    data: () => ({
        currentValue: '',
        active: false,
        beforeInput: false,
    }),
    computed: {
        filled() {
            return this.active || this.currentValue;
        },
    },
    methods: {
        clearTextSelection() {
            this.$refs.input.setSelectionRange(0, 0);
        },
        completeInputs: debounce(function(v){
            this.$emit('debounce-end', { value: v });
        }, 300),

        inputf(e) {
            this.beforeInput = true;
            this.active = true;
            this.completeInputs(e.target.value);
        },

        emitValue(e, item){
            this.active = false;

            if (this.getText(item) === this.currentValue) {
                return;
            }
            this.currentValue = this.getText(item);
            this.active = false;

            if (this.valKeyPath) {
                this.$emit('change', this.getValue(item));
            } else {
                this.$emit('change', item);
            }
            this.$emit('selected', item);
        },
        getText(obj) {
            if (obj === '') {
                return '';
            }
            for (let i = 0; i < this.vizKeyPath.length; i++) {
                let pathObj = {};
                Object.assign(pathObj, obj);
                for (let j = 0; j < this.vizKeyPath[i].length; j++) {
                    if (pathObj[this.vizKeyPath[i][j]]) {
                        pathObj = pathObj[this.vizKeyPath[i][j]];
                    } else {
                        pathObj = null;
                        break;
                    }
                }
                if (pathObj) {
                    return pathObj;
                }
            }
            return null   ;
        },
        getValue(obj) {
            if (!this.valKeyPath) return obj;

            for (let i = 0; i < this.valKeyPath.length; i++) {
                let pathObj = {};
                Object.assign(pathObj, obj);
                for (let j = 0; j < this.valKeyPath[i].length; j++) {
                    if (pathObj[this.valKeyPath[i][j]]) {
                        pathObj = pathObj[this.valKeyPath[i][j]];
                    } else {
                        pathObj = null;
                        break;
                    }
                }
                if (pathObj) {
                    return pathObj;
                }
            }
            return '';
        },
        blurClose(){
            setTimeout(() => {
                this.active = false;
            }, 350);
        },
        removeItem(e) {
            this.$emit('change', '');
            this.$emit('clear');
            this.currentValue = '';
        },

        setCurrentValue(newV) {
            let newValue = null;

            const isObject = newV && typeof newV === 'object';

            if (this.itemSelected) {
                newValue = this.getText(this.itemSelected);
            } else if (this.items) {
                const v = isObject ? this.getValue(newV) : (newV || '').toString();

                const itm = this.items.find((item)=>{
                    return newV === this.getValue(item).toString();
                });

                newValue = itm ? this.getText(itm) : '';
            } else {
                newValue = isObject ? this.getText(newV) : (newV || '').toString();
            }

            if (newValue) {
                this.currentValue = newValue;
            } else {
                this.currentValue = '';
            }

            if(this.isMultipleLines) {
              this.$refs.area.style.height = '44px';
              this.$refs.area.style.height = `${this.$refs.area.scrollHeight}px`;
            }
        },
    },
    mounted() {
      let newValue = null;
      if (this.valKeyPath) {
        if (this.itemSelected) {
                newValue = this.getText(this.itemSelected);
            } else if (this.items) {
              const itm = this.items.find((item)=>{
                return this.value === this.getValue(item);
              });
                if (itm) {
                    newValue = this.getText(itm);
                }
              }
        } else {
            newValue = this.getText(this.value);
        }
        if (newValue !== null) {
            this.currentValue = newValue;
        }
        this.completeInputs('');
        if(this.isMultipleLines) {
          setTimeout(() => {
            this.$refs.area.style.height = `${this.$refs.area.scrollHeight}px`;
          }, 300);
        }
    },
    watch: {
        itemSelected(itm) {
            if (itm) {
                this.currentValue = this.getText(itm);
            } else {
                this.currentValue =  '';
            }
        },
        value: {
            handler: function (newV) {
                this.setCurrentValue(newV);
                this.completeInputs('');
            },
            deep: true,
        },
        items: {
            handler: function () {
                if (!this.beforeInput) {
                    this.setCurrentValue(this.value);
                } else {
                    this.beforeInput = false;
                }
            },
            deep: true,
        },
        active(v) {
            if (v) {
                this.$nextTick(() => {
                    if (this.$refs.vinput) {
                        this.$refs.vinput.focus();
                    }
                });
            }
        },
    },
    props: {
        label: String,
        inputValue: Object,
        isMultipleLines: {
          type: Boolean,
          default: false,
        },
        vizKeyPath: Array,
        valKeyPath: Array,
        items: Array,
        value: [Object, String, Number, Array],
        coins: Number,
        disabled: Boolean,
        chip: {
            type: Boolean,
            default: false,
        },
        itemSelected: [Object, String, Number, Array],
        withClear: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: '',
        },
    },


    model: {
        prop: 'value',
        event: 'change',
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mt';
@import '~@/styles/rem';

.multiple-area {
  resize: none;
  height: urem(44);
  font-size: urem(16);
  font-family: 'Proxima Nova', sans-serif;
  font-weight: 400;
}

.clear-icon {
    width: urem(25);
    height: urem(25);
    cursor: pointer;
}
</style>
